import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import userTag from './modules/userTag'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    userTag,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js